import CryptoJS from 'crypto-js'

const SECRET_KEY = 'mes_secure_session_key_2026'

/**
 * Encrypts an object and stores it in localStorage under 'session'
 * @param {Object} data - The session data to encrypt
 */
export const setEncryptedSession = (data) => {
  const jsonStr = JSON.stringify(data)
  const encrypted = CryptoJS.AES.encrypt(jsonStr, SECRET_KEY).toString()
  localStorage.setItem('session', encrypted)
}

/**
 * Decrypts the session from localStorage
 * @returns {Object|null} The decrypted session data, or null if not found/invalid
 */
export const getDecryptedSession = () => {
  try {
    const encrypted = localStorage.getItem('session')
    if (!encrypted) return null

    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY)
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8)
    return JSON.parse(decryptedStr)
  } catch (error) {
    console.error('Failed to decrypt session', error)
    return null
  }
}

/**
 * Clears the encrypted session and login state
 */
export const clearSession = () => {
  localStorage.removeItem('session')
  localStorage.removeItem('isLoggedIn')
}
